import { useState } from "react";
import { anatomyConstants } from "../../../constants/anatomyConstants";

const ScalpelModal = ({
  isMobile,
  cutHeight,
  setCutHeight,
  modelRef,
  selectedModels,
  setSelectedModels,
  setProcessing,
  modifyGeometryAndAddToScene,
  closeScalpelModal,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  // Check if mobile portrait (upside down) view
  const isMobilePortrait =
    isMobile &&
    typeof window !== "undefined" &&
    window.innerWidth < window.innerHeight;

  // Filter models based on search term
  const filteredModels = modelRef.current.children.filter((model) =>
    model.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div
      className={`absolute ${
        isMobilePortrait ? "bottom-20 left-2" : "bottom-1 left-28"
      } w-auto md:w-1/4 flex flex-col items-start z-50`}
    >
      <div
        className="relative flex flex-col items-start space-y-3 p-3 pt-2 bg-white rounded-lg shadow-lg border border-gray-200 w-40 md:w-50"
        style={{
          "--main-color": anatomyConstants.mainColor,
          "--main-color-bold": anatomyConstants.mainColorBold,
        }}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            closeScalpelModal();
          }}
          aria-label="Close"
          className="absolute top-2 right-2 w-5 h-5 rounded-full bg-gray-100 border border-[#0000001A] shadow-sm flex items-center justify-center text-gray-700 hover:bg-gray-200 z-10"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="w-3.5 h-3.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Search bar */}
        <div className="w-full">
          <label className="block text-xs text-gray-600 mb-1">
            Search Models
          </label>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="py-1 px-2 w-full bg-white border border-gray-300 rounded text-sm text-[var(--main-color)] focus:outline-none focus:ring-1 focus:ring-[var(--main-color)]"
            placeholder="Filter models"
          />
        </div>

        <div className="w-full">
          <label className="block text-xs text-gray-600 mb-1">
            Thickness (mm)
          </label>
          <input
            type="number"
            value={cutHeight}
            onChange={(e) => setCutHeight(parseFloat(e.target.value))}
            className="no-spinner py-1 px-2 w-full bg-white border border-gray-300 rounded text-sm text-[var(--main-color)] focus:outline-none focus:ring-1 focus:ring-[var(--main-color)]"
            placeholder="Height"
          />
        </div>

        <div
          className={`w-full flex flex-col space-y-2 overflow-y-auto overflow-x-hidden ${
            isMobile ? "max-h-28" : "max-h-36"
          }`}
        >
          {filteredModels.map((model) => {
            // Get the original index from modelRef.current.children
            const originalIndex = modelRef.current.children.indexOf(model);
            return (
              <label
                key={model.name}
                className="flex items-center space-x-2 w-full"
              >
                <input
                  className="accent-[var(--main-color)]"
                  type="checkbox"
                  checked={selectedModels.includes(originalIndex)}
                  onChange={() => {
                    setSelectedModels((prevSelectedModels) =>
                      prevSelectedModels.includes(originalIndex)
                        ? prevSelectedModels.filter((i) => i !== originalIndex)
                        : [...prevSelectedModels, originalIndex]
                    );
                  }}
                />
                <span className="text-sm md:text-xs text-gray-700">
                  {model.name}
                </span>
              </label>
            );
          })}
        </div>

        <div className="flex w-full justify-between items-center space-x-2">
          <button
            title="Performs the cut operation at the specified height."
            onClick={(e) => {
              e.stopPropagation();
              setProcessing(true);
              setTimeout(() => {
                modifyGeometryAndAddToScene();
              }, 100);
            }}
            className="flex-1 py-2 px-3 text-sm md:text-xs font-medium text-white rounded bg-[var(--main-color)] hover:bg-[var(--main-color-bold)]"
          >
            Cut
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScalpelModal;
